import {
    ADDITIONAL_PAGE_OPTIONS,
    NSF_STORAGE_CURIOSITY_FLOW,
    SAILS_VVL_STORAGE,
    SalesChannel,
    SALESCHANNEL_CONSUMER,
    SALESCHANNEL_FAMILY_FRIENDS,
    SALESCHANNEL_SOHO,
    SALESCHANNEL_YOUNG,
} from '@vfde-sails/constants';
import {
    getSalesChannelFromNsf,
    getSalesChannelFromSails,
    getSessionStorageItemJson,
    NsfStorage,
    SailsVvlStorage,
} from '@vfde-sails/storage';

const getSalesChannel = (): Exclude<
    SalesChannel,
    typeof SALESCHANNEL_SOHO | typeof SALESCHANNEL_FAMILY_FRIENDS | typeof SALESCHANNEL_SOHO
> =>
    getSalesChannelFromSailsStorage() ?? getSalesChannelFromNsfStorage() ?? getSalesChannelFromDom();

export default getSalesChannel;

const getSalesChannelFromSailsStorage = (): Extract<SalesChannel, typeof SALESCHANNEL_CONSUMER | typeof SALESCHANNEL_YOUNG> | null => {
    const storage = getSessionStorageItemJson<SailsVvlStorage>(SAILS_VVL_STORAGE);

    if (!storage) {
        return null;
    }

    const salesChannel = getSalesChannelFromSails(storage);

    if (!isValidSalesChannel(salesChannel)) {
        return null;
    }

    return salesChannel;
};

const getSalesChannelFromNsfStorage = (): Extract<SalesChannel, typeof SALESCHANNEL_CONSUMER | typeof SALESCHANNEL_YOUNG> | null => {
    const storage = getSessionStorageItemJson<NsfStorage>(NSF_STORAGE_CURIOSITY_FLOW);

    if (!storage) {
        return null;
    }

    const salesChannel = getSalesChannelFromNsf(storage);

    if (!isValidSalesChannel(salesChannel)) {
        return null;
    }

    return salesChannel;
};

const getSalesChannelFromDom = (): Exclude<
    SalesChannel,
    typeof SALESCHANNEL_SOHO | typeof SALESCHANNEL_FAMILY_FRIENDS | typeof SALESCHANNEL_SOHO
> =>
    window[ADDITIONAL_PAGE_OPTIONS].salesChannel;

/**
 * Checks if sales channel is either Young or Consumer
 */
export const isValidSalesChannel = (
    salesChannel?: SalesChannel | null,
): salesChannel is Extract<SalesChannel, typeof SALESCHANNEL_CONSUMER | typeof SALESCHANNEL_YOUNG> =>
    !!salesChannel && [SALESCHANNEL_YOUNG, SALESCHANNEL_CONSUMER].includes(salesChannel);
